import { FC } from "react";

import { Stack, SxProps, Theme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTooltip } from "@/forms-design-system/FormTooltip";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Verified } from "@/icons/filled";

interface VerifiedOrganizationBadgeProps {
  sx?: SxProps<Theme>;
}

export const VerifiedOrganizationBadge: FC<VerifiedOrganizationBadgeProps> = ({ sx }) => {
  const { t } = useTranslate();

  return (
    <FormTooltip title={t("ticketing", "verifiedOrganization.tooltip")} placement="right">
      <Stack
        direction="row"
        alignItems="center"
        gap={0.25}
        width="fit-content"
        data-test="verified-organization-badge"
        sx={mergeSx(sx)}
      >
        <FormIcon
          size="small"
          sx={(theme: Theme) => ({
            color: theme.palette.forms.border.positive,
            "& path:last-of-type": { fill: theme.palette.forms.text.reverse },
          })}
        >
          <Verified />
        </FormIcon>
        <FormTypography variant="caption" vibe="moderate">
          {t("ticketing", "verifiedOrganization.label")}
        </FormTypography>
      </Stack>
    </FormTooltip>
  );
};
